
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getJobs } from '@/api';
import { LegacyJob } from '../types';
import JobRow from './JobRow';

// 使用 LegacyJob 类型用于向后兼容
type Job = LegacyJob;

interface HotJobsProps {
  onViewAll: () => void;
  onSelectJob: (job: Job) => void;
}

const HotJobs: React.FC<HotJobsProps> = ({ onViewAll, onSelectJob }) => {
  const { t } = useTranslation();
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const data = await getJobs();

        // 优先显示急招岗位 (priority: 'HIGH')，然后按其他条件排序
        const urgentJobs = data.filter(job => job.priority === 'HIGH');
        const otherJobs = data.filter(job => job.priority !== 'HIGH').slice(0, 6 - urgentJobs.length);

        // 合并急招和其他岗位，取前6个
        const sortedJobs = [...urgentJobs, ...otherJobs].slice(0, 6);
        setJobs(sortedJobs);
      } catch (error) {
        console.error('Failed to load jobs:', error);
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  if (loading) {
    return (
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 pb-16 sm:pb-24">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </section>
    );
  }

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 pb-16 sm:pb-24">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 sm:mb-12 gap-4 sm:gap-6">
        <div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-2 sm:mb-4 tracking-tight">{t('hotJobs.title')}</h2>
          <p className="text-base sm:text-lg text-slate-500 max-w-3xl">
            {t('hotJobs.description')}
          </p>
        </div>
        <button
          onClick={onViewAll}
          className="flex items-center gap-2 font-bold text-blue-600 hover:text-blue-700 transition-colors group text-sm sm:text-base cursor-pointer"
        >
          {t('hotJobs.viewAll')}
          <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>

      {/* 统一使用列表样式，带分隔线 */}
      <div className="bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm divide-y divide-slate-50">
        {jobs.map((job) => (
          <JobRow key={job.id} job={job} onSelect={onSelectJob} />
        ))}
      </div>


      {/* <div className="mt-12 sm:mt-20 text-center">
        <div className="inline-block p-6 sm:p-12 bg-blue-50 rounded-2xl sm:rounded-[40px] max-w-4xl w-full">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-10 text-center md:text-left">
            <div className="flex-1">
              <h3 className="text-xl sm:text-2xl font-bold text-slate-900 mb-2 sm:mb-4">Don't see a role that fits?</h3>
              <p className="text-slate-600 text-sm sm:text-base">
                Submit your CV to our talent community, and we'll reach out when a suitable position becomes available.
              </p>
            </div>
            <button className="bg-slate-900 text-white px-6 sm:px-10 py-3 sm:py-5 rounded-xl sm:rounded-2xl font-bold text-sm sm:text-lg hover:scale-105 transition-transform shadow-xl w-full sm:w-auto">
              Join Talent Pool
            </button>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default HotJobs;
